const firebaseConfig = {
  apiKey: "AIzaSyCQ1IFIztgc_09eHsuJUu9sMxUjtC4LXlA",
  authDomain: "lead-manager-react.firebaseapp.com",
  databaseURL: "https://lead-manager-react.firebaseio.com",
  projectId: "lead-manager-react",
  storageBucket: "lead-manager-react.appspot.com",
  messagingSenderId: "1091815738357",
  appId: "1:1091815738357:web:d8c49b6759b759324b6ebc"
};

export default firebaseConfig;
